import { render, staticRenderFns } from "./GraficoBarraStacked.vue?vue&type=template&id=5a99c012&"
import script from "./GraficoBarraStacked.vue?vue&type=script&lang=ts&"
export * from "./GraficoBarraStacked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports